import { Injectable } from '@angular/core';
import { NavigationBehaviorOptions, Route, Router, Routes } from '@angular/router';

export const ROUTE_METADATA = {
	Empty: {
		id: -1,
	},
	Login: {
		id: -2
	},
	RedirectAccess: {
		id: -7
	},
	ForgotPassword: {
		id: -3
	},
	NotFound: {
		id: -4
	},
	DealerPortalAuth: {
		id: -5
	},
	// Help: {
	// 	id: 32,
	// 	name: 'HelpListComponent', // Not possible to use `(new ClassName).constructor.name` or `ClassName.name` because it can be changed during minification process. TS doesn't have static compile time type name getter.
	// 	text: 'Help',
	// 	icon: 'fa-solid fa-question-circle',
	// },

	//TODO: delete these from here once we have the agnostic method working for dynamic routes.
	NetworkDeepDive: {
		id: 26
	},

	ChangePassword: {
		id: 51,
	},
	UserSettings: {
		id: 55
	},

	Home: {
		id: 66
	},
};
export type RouteMetadata = typeof ROUTE_METADATA[keyof typeof ROUTE_METADATA];
export type RouteNames = keyof typeof ROUTE_METADATA;

export type ComponentRouteData = {
	route: Route;
	routeFullPath: string;
};

@Injectable({
	providedIn: 'root'
})
export class NavigationService {

	private _componentRouteLookup: Map<number, { route: Route, routeFullPath: string }> = new Map();

	public routesMetadata: { [key in RouteNames]?: { route: Route, routeFullPath: string } } = {};

	public resetComponentRouteLookup(routes: Routes): void {
		this._componentRouteLookup = new Map();

		const addRecord: (route: Route, relativePath: string) => void = (route: Route, relativePath: string): void => {
			if (!route.data || !route.data.id) {
				return;
			}

			let path: string = [relativePath, route.path].join('/');

			if (route.data.id) {
				this._componentRouteLookup.set(route.data.id, { route: route, routeFullPath: path });
			}

			if (route.children) {
				for (let a = 0; a < route.children.length; a++) {
					addRecord(route.children[a], path);
				}
			}
		}

		for (let a = 0; a < routes.length; a++) {
			addRecord(routes[a], '');
		}

		for (const routeName in ROUTE_METADATA) {
			const routeMetadata = ROUTE_METADATA[routeName];

			this.routesMetadata[routeName] = this.getComponentRouteData(routeMetadata);
		}
	}

	// public getComponentRouteData<T>(component: { new(...args: any[]): T; }): { route: Route, routeFullPath: string} {
	// 	console.warn('getComponentRouteData');

	// public navigate<T>(component: { new(...args: any[]): T; }): void {
	// 	const componentRouteData: { route: Route, routeFullPath: string} = this.getComponentRouteData(component);

	public getComponentRouteData(routeMetadata: RouteMetadata): ComponentRouteData {
		const data = routeMetadata;

		return this._componentRouteLookup.get(data.id);
	}

	public navigate(routeMetadata: RouteMetadata, navigationBehaviorOptions?: NavigationBehaviorOptions): void {
		const componentRouteData: ComponentRouteData = this.getComponentRouteData(routeMetadata);

		this._router.navigateByUrl(componentRouteData.routeFullPath, navigationBehaviorOptions);
	}

	constructor(
		private _router: Router,
	) { }
}
